import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import hero from '../assets/images/hero/compras.jpg'
import { useState, useEffect } from 'react';
import useAuthStatus from '../hooks/useAuthStatus'
import { Helmet } from 'react-helmet-async'

export default function Pedidos() {
    const { status } = useAuthStatus();
    const csrfToken = localStorage.getItem('token');
    if (csrfToken == null) {
        window.location.href = '/login';
    }
    const [pedidos, setPedidos] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);

    useEffect(() => {
        if (!csrfToken) {
            return;
        }
        const API_URL = process.env.REACT_APP_API_URL;
        const fetchPedidos = async (page) => {
            const formatPrice = (price) => {
                return price ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0';
            };
            const transformData = (data) => {
                return data.map(item => ({
                    id: item.id,
                    name: item.name,
                    orderdate: formattedDate(item.orderdate),
                    orderstatus: item.orderstatus,
                    ordertotal: formatPrice(item.ordertotal),
                    paymentmethod: item.paymentmethod,
                    paymentstatus: item.paymentstatus,
                    product: item.listing,
                    customername: item.customername,
                }));
            };
            try {
                fetch(`${API_URL}/api/purchases?page=${page}`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'X-CSRF-TOKEN': csrfToken,
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    }
                }).then(response => {
                    if (response.status === 401) {
                        window.location.href = '/logout';
                        return null;
                    }
                    if (response.status === 404 || response.status === 403) {
                        window.location.href = '/';
                        return null;
                    }
                    return response.json();
                }).then(data => {
                    if (!data || !data.data) {
                        console.error('Invalid data format:', data);
                        return;
                    }

                    setPedidos(transformData(data.data));
                    setLastPage(data.last_page);
                })
                    .catch(error => console.error('Error fetching data:', error));
            } catch (error) {
                console.error('Error fetching pedidos:', error);
            }
        };
        if (status === null) {
            return;
        }
        fetchPedidos(currentPage);
    }, [currentPage, csrfToken, status]);

    const formattedDate = (datedata) => {
        return new Date(datedata).toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }

    const handlePageChange = (page) => {
        if (page >= 1 && page <= lastPage) {
            setCurrentPage(page);
        }
    };

    if (status === null) {
        return (
            <div id='LoyaltyProgram'>
                <Navbar />
                <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                    <div className="bg-overlay bg-gradient-overlay"></div>
                    <div className="container">
                        <div className="row mt-5 justify-content-center">
                            <div className="col-12">
                                <div className="title-heading text-center">
                                    <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Mis pedidos</h5>
                                </div>
                            </div>
                        </div>

                        <div className="position-middle-bottom">
                            <nav aria-label="breadcrumb" className="d-block">
                                <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Pedidos</li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </section>

                <div className="position-relative">
                    <div className="shape overflow-hidden text-white">
                        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                        </svg>
                    </div>
                </div>
                <section className="section bg-inverted pt-3">
                    <div className="container">
                        <div className="row justify-content-center">

                            <div className="col-lg-7 col-12 mt-4 mt-md-0 p-4 pt-4 pt-md-0">
                                <div className="section-title ms-lg-5 text-center">
                                    Cargando...
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
                <ScrollToTop />
            </div>
        )
    }
    return (
        <>
            <Helmet>
                <title>Mis pedidos | Hospital Aranda de La Parra</title>
                <meta name="description" content="Hospital Aranda de La Parra" />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Mis pedidos</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Pedidos</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 mb-5 mb-md-0 pb-5 pb-md-4">
                            <h3>Pedidos</h3>
                            <p>
                                Esta es la lista de pedidos que ha realizado. Si desea ver el detalle de cada uno, haga clic en el botón correspondiente.
                            </p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 mb-5 mb-md-0 pb-5 pb-md-4">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Producto</th>
                                        <th>Fecha</th>
                                        <th>Total</th>
                                        <th>Método de pago</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pedidos.length === 0 ? (
                                        <tr>
                                            <td colSpan="6" className="text-center">No hay pedidos disponibles.</td>
                                        </tr>
                                    ) : (
                                        pedidos.map((pedido) => (
                                            <tr key={pedido.id}>
                                                <td className="small">
                                                    <Link to={`/pedido/${pedido.id}`}>
                                                        {pedido.id}
                                                    </Link>
                                                </td>
                                                <td className="small">{pedido.name}</td>
                                                <td className="small">{pedido.orderdate}</td>
                                                <td className="small">${pedido.ordertotal}</td>
                                                <td className="small">{pedido.paymentmethod}</td>
                                                <td className="small">
                                                    <Link to={`/pedido/${pedido.id}`} className="btn btn-primary btn-sm py-1">
                                                        Ver Detalle
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                            <div className="d-flex justify-content-between align-items-center">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    Anterior
                                </button>
                                <span>Página {currentPage} de {lastPage}</span>
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === lastPage}
                                >
                                    Siguiente
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </>
    )
}
